export default function Programs() {
  return (
    <section id="programs" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2723] mb-4">
            Esto NO es Solo una Clase de Música
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Es confianza, enfoque, responsabilidad y orgullo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="relative rounded-3xl overflow-hidden shadow-xl h-[500px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/72565da58b9cde913c695a82827891c8.jpg" 
              alt="Estudiante practicando"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-6 left-6 bg-black/70 backdrop-blur-sm px-6 py-4 rounded-2xl">
              <p className="text-white font-semibold text-lg">Desarrollo Individual</p>
              <p className="text-gray-300 text-sm">De principiante a avanzado</p>
            </div>
          </div>

          <div className="flex flex-col gap-8">
            <div className="relative rounded-3xl overflow-hidden shadow-xl h-[240px] bg-[#E8F5E9]">
              <img 
                src="https://readdy.ai/api/search-image?query=Beautifully%20arranged%20traditional%20mariachi%20instruments%20including%20violins%20guitars%20guitarron%20and%20trumpet%20displayed%20on%20a%20simple%20clean%20light%20green%20background%20with%20soft%20studio%20lighting%20showing%20the%20craftsmanship%20and%20cultural%20heritage%20of%20Mexican%20music%20instruments%20professional%20product%20photography%20style&width=900&height=500&seq=prog002&orientation=landscape" 
                alt="Instrumentos mariachi"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="relative rounded-3xl overflow-hidden shadow-xl h-[240px] bg-[#FCE4EC]">
              <img 
                src="https://readdy.ai/api/search-image?query=Group%20of%20diverse%20children%20and%20teenagers%20in%20colorful%20mariachi%20outfits%20performing%20together%20on%20stage%20with%20bright%20stage%20lights%20showing%20teamwork%20confidence%20and%20joy%20playing%20violins%20trumpets%20and%20guitars%20in%20perfect%20harmony%20with%20warm%20pink%20stage%20lighting%20professional%20concert%20photography&width=900&height=500&seq=prog003&orientation=landscape" 
                alt="Presentación grupal"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#FFF8E1] to-[#FFECB3] rounded-3xl p-12 shadow-lg">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-start gap-6 mb-8">
              <div className="w-16 h-16 bg-[#D2691E] rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-music-2-fill text-3xl text-white"></i>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-[#3E2723] mb-4">¿Por Qué Mariachi?</h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  El mariachi es más que música. Es herencia. Disciplina. Pasión. Identidad.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed">
                  A través del mariachi, los niños se conectan con la cultura, aprenden respeto por la tradición y experimentan la alegría de crear algo significativo juntos.
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-12 h-12 bg-[#D2691E]/10 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-emotion-happy-line text-2xl text-[#D2691E]"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Para niños tímidos</h4>
                <p className="text-gray-600 text-sm">Construye confianza</p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-12 h-12 bg-[#D2691E]/10 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-focus-line text-2xl text-[#D2691E]"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Para niños enérgicos</h4>
                <p className="text-gray-600 text-sm">Trae enfoque</p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-12 h-12 bg-[#D2691E]/10 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-star-line text-2xl text-[#D2691E]"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Para niños talentosos</h4>
                <p className="text-gray-600 text-sm">Da dirección</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
